interface PlaygroundRoutingDebugPanelProps {
  routing: Record<string, unknown>;
}

const Row = ({ label, value }: { label: string; value: string }) => (
  <p>
    <span className="font-semibold">{label}:</span> {value}
  </p>
);

export const PlaygroundRoutingDebugPanel = ({ routing }: PlaygroundRoutingDebugPanelProps) => {
  const resetFlags = Array.isArray(routing.resetFlags) ? routing.resetFlags : [];

  return (
    <div className="rounded-xl border border-black/10 bg-white p-5 shadow-sm">
      <h3 className="text-base font-semibold text-brand-blue">Routing Debug</h3>
      <div className="mt-3 space-y-2 text-xs text-brand-blue">
        <p>
          <span className="font-semibold">Trace:</span>{' '}
          <span className="break-all font-mono">{String(routing.traceId ?? 'okänd')}</span>
        </p>
        <Row label="Lane" value={String(routing.lane ?? 'okänd')} />
        <Row label="Canonical action" value={String(routing.canonicalAction ?? 'saknas')} />
        <Row label="Executor" value={String(routing.executor ?? 'okänd')} />
        <Row label="Fallback" value={String(routing.fallbackPolicy ?? 'direct')} />
        {resetFlags.length > 0 ? <Row label="Reset flags" value={resetFlags.join(', ')} /> : null}
      </div>
    </div>
  );
};
